import { memo } from 'react';
import { deriveStyle } from './utils';
import { Container } from './styled';
export const TextItemLayer = memo((props) => {
    const { str, scale, transform, viewport, textStyle } = props;
    const { fontFamily } = textStyle;
    const style = Object.assign(Object.assign({}, deriveStyle({ viewport, transform, scale })), { fontFamily });
    return <Container style={style}>{str}</Container>;
});
